export default __webpack_public_path__ + "static/media/instruments.2e8cb2ed.svg";